import { gql } from '@apollo/client';

export const updateRolesForUser_Name = 'UpdateUserRoles';
export const updateRolesForUser_Gql = gql`
  mutation UpdateUserRoles($userId: ID!, $roleIds: [ID!]!) {
    updateUserRoles(userId: $userId, roleIds: $roleIds)
  }
`;
